<template>
  <div>
    <vxe-grid
      auto-resize
      ref="vxeGrid"
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :height="tableHeight"
      class="bg-white"
      :loading="loading"
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"> </slot>
      </template>

      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.appraisalBillStatus === 'Y' ? 'light' : 'warning'"
          >{{ row.appraisalBillStatusName }}</el-tag
        >
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="fromLoad('detail', row.appraisalBillCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              @click="fromLoad('edit', row.appraisalBillCode)"
              class="el-icon-edit tool-btn"
            ></i>
            "
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D')"
          >
            <i
              @click="del(row.appraisalBillCode)"
              class="el-icon-delete tool-btn"
            ></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tablePage: {
      default: null,
      type: Object
    },
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('submit')
        },
        zoom: true,
        custom: true
      },
      // 表单设置
      formOption: {
        title: '',
        dialogFormVisible: false,
        dialogSaveBtnVisible: true
      },
      tableColumns: tableColumns(this)
    }
  },
  methods: {
    // 加载表单
    fromLoad(ref, val = '') {
      let params = {
        appraisalBillCode: val,
        pageType: ref
      }
      // 跳转页面
      this.$router.push({
        name: 'resourceManagement-scmAppraisalBillDetail',
        params: params
      })
    },
    del(appraisalBillCode) {
      this.$confirm(
        this.$l('INDEX.tips_question_delete') || '是否删除？',
        this.$l('INDEX.tips_question_title') || '提示',
        {
          confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$api
            .scmAppraisalBillDelApi({ appraisalBillCode: appraisalBillCode })
            .then(() => {
              this.$message.success(
                this.$l('INDEX.tips_delete_ok') || '删除成功'
              )
              this.$emit('submit')
            })
        })
        .catch(() => {})
    },
    save() {
      this.$refs.form.save()
    },
    saveSuccess() {
      this.cancel()
      this.$emit('submit')
    },
    cancel() {
      this.formOption.dialogFormVisible = false
    }
  }
}
</script>
